import { render, staticRenderFns } from "./infos-shop-order.vue?vue&type=template&id=1507114b"
import script from "./infos-shop-order.vue?vue&type=script&lang=ts"
export * from "./infos-shop-order.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1507114b')) {
      api.createRecord('1507114b', component.options)
    } else {
      api.reload('1507114b', component.options)
    }
    module.hot.accept("./infos-shop-order.vue?vue&type=template&id=1507114b", function () {
      api.rerender('1507114b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "orders/infos-shop-order.vue"
export default component.exports